export default "__VITE_ASSET__Bl5_S0f2__"